module.exports = "/static/assets/8c6be33fc9a8eadffa880c9fe0ca6340.png";